export enum KnmResponsibleTypeCodesEnum {
  ULIP = 'ULIP',
  FIZ = 'FIZ',
  UR = 'UL',
  IP = 'IP',
  IFIZ = 'IFIZ',
  IUR = 'IUL',
  FIUR = 'FIUL',
  OFFICIAL = 'OFFICIAL',
}
